import React, { createClass, PropTypes } from 'react';
import getClassNames from 'classnames';
import { Paper } from 'material-ui';
import Icon from './icon';
import { IconButton } from 'material-ui';


const DropDown = createClass({

  propTypes: {
    iconClassName: PropTypes.string,
    tooltip: PropTypes.string,
    className: PropTypes.string,
    label: PropTypes.string,
    componentClassName: PropTypes.string,
    options: PropTypes.array,
    style: PropTypes.object,
  },

  getInitialState() {
    return {
      showDropDown: false,
      isOnNestedMultiselect: false,
      menuMap: [],
    };
  },

  componentClickAway() {
    this.setState({
      showDropDown: false,
    });
  },

  _actionButtonClicked() {
    this.setState({
      showDropDown: !this.state.showDropDown,
    });
  },

  _optionClicked(option, index) {
    switch (option.type) {
      case 'nestedmenu':
        // show the other menu
        this.state.menuMap.push(index);
        this.setState({
          menuMap: this.state.menuMap,
          isOnNestedMultiselect: option.isOnNestedMultiselect,
        });
        break;
      default:
        if (typeof option.action === 'function') {
          option.action();
        }
        if (!option.leaveMenuOpen) {
          this.setState({
            showDropDown: false,
          });
        }
        break;
    }
  },

  _showPrevious() {
    this.state.menuMap.pop();
    this.setState({
      menuMap: this.state.menuMap,
      isOnNestedMultiselect: false,
    });
  },

  render() {
    const iconClassName = this.props.iconClassName || 'tc-icon-more-vert';
    const tooltip = this.props.tooltip === false ? undefined : 'More Actions';

    let menuToDisplay = this.props.options;
    let menuText;
    let filterIcon;
    this.state.menuMap.forEach(index => {
      menuText = menuToDisplay[index].text;
      menuToDisplay = menuToDisplay[index].subOptions;
    });

    const menu = menuToDisplay.map((option, index) => {
      return (
        <div onClick={() => this._optionClicked(option, index)} className="more-vert-link" key={index}> {option.text} {option.icon} </div>
      );
    });
    const classes = getClassNames('more-vert-drop-down', this.props.className, {
      'is-closed': !this.state.showDropDown,
      'is-vert-multi-select': this.state.isOnNestedMultiselect,
    });
    const previousButton = this.state.menuMap.length ? <div onClick={this._showPrevious} className="more-vert-link"> <Icon className="tc-icon-chevron-left"/>{menuText}</div> : null;

    if (this.props.label) {
      filterIcon = <div className="more-vert-label" onClick={this._actionButtonClicked}>{this.props.label}</div>;
    } else {
      filterIcon = (
        <IconButton
          iconClassName={iconClassName}
          onTouchTap={this._actionButtonClicked}
          tooltip={tooltip}
        />
      );
    }

    return (
      <div className={`${this.props.componentClassName} more-vert`} style={this.props.style}>
        <Paper
          style={{ zIndex: 1 }}
          className={classes}
        >
            {previousButton}
            {menu}
        </Paper>
          {filterIcon}
      </div>
    );
  },
});

export default DropDown;



// WEBPACK FOOTER //
// ./src/app/components/tc-ui/vert-dropdown.jsx